import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
  IconButton,
  TableContainer,
  Paper,
  TextField,
  Box
} from '@mui/material';
import { api } from '../helpers/apiRequest';
import { toast } from 'react-toastify';
import { Edit, Delete } from '@mui/icons-material';
import colors from '../theme/Colors';
import { styled } from '@mui/material/styles';

const ManagementDialog = ({ open, onClose, type, partyId,pstyle }) => {
  console.log("partyId",partyId);
  const [data, setData] = useState([]);
  const [userInfo] = useState(JSON.parse(localStorage.getItem('user')));
  const [editingId, setEditingId] = useState(null);
  const [editedName, setEditedName] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [party_name,setPartyName]=useState('');
  useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [open, type]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const fetchData = async () => {
    try {
      let response;
      let endpoint;
      switch (type) {
        case 'party':
          endpoint =
            userInfo?.role === 'merchant'
              ? `inventory/party/merchant/${userInfo?.id}`
              : `inventory/party`;
          response = await api.get(endpoint);
          break;
        case 'style':
          endpoint =
            (userInfo?.role === 'merchant' || userInfo?.role === 'admin') && partyId
              ? `inventory/styles_party?party=${partyId}`
              : `inventory/styles`;
          response = await api.get(endpoint);
          break;
        case 'item':
          endpoint =
          (userInfo?.role === 'merchant' || userInfo?.role === 'admin') && partyId && pstyle
              ? `inventory/items_party?party=${partyId}&pstyle=${pstyle}`
              : (userInfo?.role === 'merchant' || userInfo?.role === 'admin') && partyId ?`inventory/items_party?party=${partyId}`:`inventory/items`;
          response = await api.get(endpoint);
          break;
        case 'pStyle':
          endpoint =
          (userInfo?.role === 'merchant' || userInfo?.role === 'admin') && partyId
              ? `inventory/pstyles_party?party=${partyId}`
              : `inventory/pstyles`;
          response = await api.get(endpoint);
          break;
        case 'color':
          endpoint = `inventory/colors`;
          response = await api.get(endpoint);
          break;
        default:
          return;
      }
      setData(response.data.message || []);
      setPartyName(response?.data?.party_name);
    } catch (error) {
      console.error(`Error fetching ${type}:`, error);
      toast.error(`Failed to fetch ${type}`);
    }
  };

  const handleEditStart = (item) => {
    setEditingId(item._id);
    setEditedName(item.name);
  };

  // const handleEditSave = async (id) => {
  //   const updatedData = { name: editedName };
  //   await handleEdit(id, updatedData);
  //   setEditingId(null);
  // };

  const handleEditSave = async (id) => {
    try {
      const updatedData = { name: editedName };
      let endpoint = `inventory/${type}/${id}`;
      if (type === 'pStyle') {
        endpoint = `inventory/pstyles/${id}`;
      } else if (type === 'item') {
        endpoint = `inventory/items/${id}`;
      } else if (type === 'style') {
        endpoint = `inventory/styles/${id}`;
      } else if (type === 'color') {
        endpoint = `inventory/color/${id}`;
      }

      await api.put(endpoint, updatedData);
      toast.success(
        `${type.charAt(0).toUpperCase() + type.slice(1)} updated successfully`
      );
      fetchData();
    } catch (error) {
      console.error(`Error updating ${type}:`, error);
      toast.error(`Failed to update ${type}`);
    }
  };

  const handleDelete = async (id) => {
    try {
      let endpoint = `inventory/${type}/${id}`;
      if (type === 'pStyle') {
        endpoint = `inventory/pstyles/${id}`;
      } else if (type === 'item') {
        endpoint = `inventory/items/${id}`;
      } else if (type === 'style') {
        endpoint = `inventory/styles/${id}`;
      } else if (type === 'color') {
        endpoint = `/color/${id}`;
      }

      await api.delete(endpoint);
      toast.success(
        `${type.charAt(0).toUpperCase() + type.slice(1)} deleted successfully`
      );
      fetchData();
    } catch (error) {
      console.error(`Error deleting ${type}:`, error);
      toast.error(`Failed to delete ${type}`);
    }
  };

  // filter data based on search query
  const filteredData = data.filter((item) =>
    item.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography
          variant="h6"
          align="center"
          sx={{ fontWeight: 'bold', color: colors.primary }}
        >
          Manage {type.charAt(0).toUpperCase() + type.slice(1)}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {/* Search Box */}
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <TextField
            label="Search"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ width: '60%' }}
          />
        </Box>

        <TableContainer component={Paper} sx={{ maxWidth: '600px', margin: '0 auto' }}>
          <Table>
            <TableHead sx={{ backgroundColor: colors.primary }}>
              <TableRow>
                <TableCell sx={{ width: '35%' }}>
                  {type.charAt(0).toUpperCase() + type.slice(1)} Name
                </TableCell>
                {type !== 'party' && type !== 'color' && (
                  <TableCell sx={{ width: '35%' }}>Party Name</TableCell>
                )}
                <TableCell sx={{ width: '30%' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <StyledTableRow key={item._id}>
                    <StyledTableCell sx={{ width: '35%' }}>
                      {editingId === item._id ? (
                        <TextField
                          value={editedName}
                          onChange={(e) => setEditedName(e.target.value)}
                          onBlur={() => handleEditSave(item._id)}
                          autoFocus
                        />
                      ) : (
                        item.name
                      )}
                    </StyledTableCell>
                    {type !== 'party' && (
                      <StyledTableCell sx={{ width: '35%' }}>
                        {item?.party?.name || party_name || 'N/A'}
                      </StyledTableCell>
                    )}
                    <StyledTableCell sx={{ width: '30%', whiteSpace: 'nowrap' }}>
                      {editingId === item._id ? (
                        <Button onClick={() => handleEditSave(item._id)}>
                          Save
                        </Button>
                      ) : (
                        <>
                          <IconButton onClick={() => handleEditStart(item)}>
                            <Edit />
                          </IconButton>
                          <IconButton onClick={() => handleDelete(item._id)}>
                            <Delete />
                          </IconButton>
                        </>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManagementDialog;
